(ns manage.product-selector-page.sections.required-fields
  (:require ["react-hook-form" :as rhf]
            [clojure.string :as str]
            [common.form :as form]
            [common.widgets.form-field :refer [form-field]]
            [manage.product-selector-page.hooks :as hooks]
            [manage.product-selector-page.widgets :as widgets]
            [uix.core :refer [$ defhook defui]]))

(defhook use-required-field-options []
  (let [field-options (hooks/use-field-options)]
    (remove #(#{"sku" "updated-at"} (:name %)) field-options)))

(defui edit []
  (let [{:keys [control]} (form/use-form-context)]
    ($ form-field
       {:label "Product field(s)"}
       ($ form/autocomplete-field
          {:control control
           :name "query.required-fields"
           :field-props {:options (use-required-field-options)
                         :multi? true
                         :clearable? true
                         :placeholder "None"}}))))

(defui read []
  (let [{:keys [control]} (form/use-form-context)
        required-fields (rhf/useWatch #js {:name "query.required-fields" :control control})]
    (if (seq required-fields)
      ($ form-field
         {:label "Only serve products that have values for selected fields"}
         ($ :span (str/join ", " required-fields)))
      ($ widgets/empty-section-message {:step-label "Required fields"}))))

(defui required-fields []
  (let [{:keys [mode]} (form/use-form-context)]
    ($ widgets/section-card
       {:title "Required fields"
        :tooltip "Choose the fields that must contain data. Products missing these fields will be excluded."}
       (if (= mode :read)
         ($ read)
         ($ edit)))))
